import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    q: "¿De verdad no vais a contactar a mi cliente por vuestra cuenta?",
    a: "No. Firmamos un acuerdo de confidencialidad y no captación: tu cliente es tu cliente. Toda la comunicación comercial pasa por ti y, si vamos a la grabación, nos presentamos como parte de tu equipo de producción.",
  },
  {
    q: "¿Cómo funcionan las tarifas de partner?",
    a: "Tienes un precio de partner por jornada de grabación y paquete de entregables, distinto del precio público. El margen que le sumes a tu cliente lo decides tú. Las condiciones concretas las cerramos en la reunión, adaptadas al volumen que traigas.",
  },
  {
    q: "Nunca he vendido audiovisual. ¿Me ayudáis a plantearlo?",
    a: "Sí. Te damos el argumentario, qué preguntar al cliente para saber si encaja, qué esperar de los primeros meses y qué no prometer. Si quieres, entramos en la reunión con tu cliente como tu equipo técnico.",
  },
  {
    q: "¿Dónde grabáis? ¿Podéis salir de Madrid?",
    a: "Trabajamos en la Comunidad de Madrid y hasta unos 70 km alrededor. Puedes elegir nuestro estudio propio en Madrid (C/ Fernando el Católico 57) o que montemos el estudio en las instalaciones de tu cliente dentro de ese radio.",
  },
  {
    q: "¿Y si mi cliente quiere su intro, sus colores y su formato?",
    a: "Es lo normal. Trabajamos con tus plantillas y tu manual de marca, o creamos la identidad audiovisual del podcast desde cero si es lo que necesitas.",
  },
  {
    q: "¿Cuánto tardáis en entregar un episodio?",
    a: "Fijamos las fechas antes de empezar y las cumplimos. En cada acuerdo dejamos por escrito el plazo de entrega del episodio y de los clips, para que tú puedas prometer una fecha a tu cliente sin miedo.",
  },
  {
    q: "¿Puedo empezar con un solo cliente para probar?",
    a: "Sí, es lo más habitual. Se arranca con una cuenta, se ve el resultado y a partir de ahí se amplía al resto de tu cartera.",
  },
  {
    q: "¿Quién factura al cliente final?",
    a: "Tú. Nosotros te facturamos a ti como proveedor y tú emites tu factura a tu cliente con tu precio.",
  },
];

export default function AgenciesFAQ() {
  const [open, setOpen] = useState(null);

  return (
    <section id="faq-agencias" className="section-spacing bg-galvani-bg" data-testid="agencies-faq">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <span className="inline-block text-xs uppercase tracking-[0.2em] text-galvani-pink font-body font-semibold mb-4">
            Preguntas de agencia
          </span>
          <h2 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-galvani-text">
            Lo que nos preguntan{" "}
            <span className="gradient-text">antes de firmar</span>
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => (
            <div
              key={f.q}
              className="rounded-2xl bg-white border border-slate-200 overflow-hidden"
              data-testid={`agencies-faq-${i}`}
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
                data-testid={`agencies-faq-toggle-${i}`}
              >
                <span className="font-heading font-semibold text-base text-galvani-text">
                  {f.q}
                </span>
                <ChevronDown
                  className={`w-5 h-5 text-galvani-purple flex-shrink-0 transition-transform ${
                    open === i ? "rotate-180" : ""
                  }`}
                />
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.25 }}
                    className="overflow-hidden"
                  >
                    <p className="px-6 pb-5 font-body text-sm text-galvani-textLight leading-relaxed">
                      {f.a}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
